'use client'
import { useAuthModal } from '@/hooks/useAuthModal'
import { cn } from '@/lib/utils'
import React from 'react'

const CTAButton = ({
  children,
  className,
  onClick,
  outlined = false,
  ...props
}: React.ButtonHTMLAttributes<HTMLButtonElement> & { outlined?: boolean }) => {
  const { onOpen } = useAuthModal()

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (onClick) onClick(e)
    onOpen({ redirectUrl: window.location.href })
  }

  return (
    <button
      className={cn(
        '!font-space-grotesk rounded-[20px] p-[16px] text-[20px] font-normal leading-none tracking-wide transition-colors duration-200',
        outlined
          ? 'border border-black bg-transparent text-black hover:bg-black hover:text-white'
          : 'bg-black text-white hover:bg-[#454545]',
        className
      )}
      onClick={handleClick}
      {...props}
    >
      {children}
    </button>
  )
}

export default CTAButton
